import styled from 'styled-components';

export default styled.h1`
  text-align: center;
  font-size: 1.2rem;
  font-weight: 500;
  margin: 0;
`;
